import {
  LoginRequestBody,
  GetCompaniesQueryParams,
  GetArtworksQueryParams,
  CreateArtworkQueryParams,
  CreateArtworkRequestBody,
  DeleteArtworkQueryParams,
  UpdateArtworkQueryParams,
} from 'types';
import { changeDataKeysCase } from 'utils';

import { axiosInstance } from './axiosInstance';

export const API = {
  login: (data: LoginRequestBody) => {
    return axiosInstance.instance!.post('token/', data);
  },
  getCompanies: (params: GetCompaniesQueryParams) => {
    return axiosInstance.instance!.get('company', { params });
  },
  getArtworks: (params: GetArtworksQueryParams) => {
    return axiosInstance.instance!.get('artwork', {
      params: changeDataKeysCase(params, 'snakeCase'),
    });
  },
  createArtwork: (data: CreateArtworkRequestBody, params: CreateArtworkQueryParams) => {
    return axiosInstance.instance!.post('artwork', data, {
      params: changeDataKeysCase(params, 'snakeCase'),
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteArtwork: (params: DeleteArtworkQueryParams) => {
    const { artworkId, ...restParams } = params;

    return axiosInstance.instance!.delete(`artwork/${artworkId}`, {
      params: changeDataKeysCase(restParams, 'snakeCase'),
    });
  },
  updateArtwork: (data: CreateArtworkRequestBody, params: UpdateArtworkQueryParams) => {
    const { artworkId, ...restParams } = params;

    return axiosInstance.instance!.patch(`artwork/${artworkId}`, data, {
      params: changeDataKeysCase(restParams, 'snakeCase'),
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
